export default{
  API: process.env.VUE_APP_BASE_API,
  VERSION: {
    version_1: 'v1.0.0',
    version_2: 'v2.0.0',
  },
  PREFIX: {
    AUTH: 'auth',// '/login','/logout','/getInfo','/captchaImage' 登录，退出登录，获取用户信息,获取图片验证码这四个接口前缀特殊处理
    SYS: 'system',//系统接口前缀
    BUSINESS: 'business',//标准地址接口前缀
  }
}
